import script from "./CollectionsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionsRow.vue?vue&type=script&setup=true&lang=js"

import "./CollectionsRow.vue?vue&type=style&index=0&id=072e5021&lang=scss&scoped=true"
script.__scopeId = "data-v-072e5021"

export default script